import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import PaymentPage from './PaymentPage';
import CheckoutPage from './CheckoutPage';
import ThankYouPage from './ThankYouPage';
import SelectTipRecipient from "./pages/SelectTipRecipient";
import TipAndReview from "./pages/TipAndReview";
import TipPaymentConfirmation from "./pages/TipPaymentConfirmation";
import Payment from "./pages/Payment";
import ExportHistory from "./pages/ExportHistory";
import NotFound from "./pages/NotFound";
import { initAmplitude, logEvent } from "./amplitude";
import getGuestId from "./storage/getGuestId";
import * as amplitude from "@amplitude/analytics-browser";

function AppWrapper() {
  return (
      <Router>
        <App />
      </Router>
  );
}

function App() {
  const location = useLocation();
  const guestId = getGuestId();

    useEffect(() => {
        initAmplitude();
        const sessionId = Date.now();
        logEvent("Session start", {
            'Guest ID': guestId,
        });
        setTimeout(() => {
            amplitude.setSessionId(sessionId);
        }, 100);

        const guestCount = new amplitude.Identify();
        guestCount.add('Guest count', 1);
        amplitude.identify(guestCount);
        logEvent("Page view", {
            Title: 'Loader',
            Path: location.pathname,
            URL: window.location.href,
            'Guest ID': guestId,
        });
  }, []);

  return (
      <Routes>
        <Route path="/team/:teamId" element={<SelectTipRecipient />} />
        <Route path="/service/:serviceId" element={<TipAndReview />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/tip-payment-confirmation" element={<TipPaymentConfirmation />} />
        <Route path="/pay/:productId" element={<PaymentPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/thanks" element={<ThankYouPage />} />
        <Route path="/export" element={<ExportHistory />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
  );
}

export default AppWrapper;
